const FooterData = [
  {
    header: "About Have A Dream",
    links: [
      { title: "About", link: "/about" },
      { title: "FAQ", link: "/faq" },
      { title: "Events", link: "/events" },
      { title: "Terms & conditions", link: "/terms&conditions" },
      { title: "Privacy Policy", link: "/policy" },
    ],
  },
  {
    header: "Join Us",
    links: [
      { title: "Programs", link: "/programs" },
      { title: "Reviews", link: "/reviews" },
      { title: "Hosting Organization", link: "/hosting" },
      { title: "Sending Organization", link: "/sending" },
    ],
  },
  {
    header: "Quick Links",
    links: [
      { title: "Contact us", link: "/contact" },
      { title: "Careers", link: "/careers" },
      { title: "Blogs", link: "/blogs" },
      { title: "Team", link: "/team" },
    ],
  },
];

export default FooterData;
